import { axisTop, axisBottom, axisRight } from 'd3-axis';
import { extent, bisector, max, min } from 'd3-array';
import { select, mouse } from 'd3-selection';
import { scaleLinear, scaleTime } from 'd3-scale';
import { format } from 'd3-format';
import { timeParse } from 'd3-time-format';
import { area, line } from 'd3-shape';

// https://www.d3-graph-gallery.com/graph/area_lineDot.html
// d3 rollup
// https://bl.ocks.org/mbostock/bb09af4c39c79cffcde4

// const chartData_Mock = {
//   "default": [{ year: 2020, quarter: 4, salary: 40000 }, { year: 2020, quarter: 3, salary: 55000 }, { year: 2020, quarter: 2, salary: 51000 }, { year: 2020, quarter: 1, salary: 50000 }, { year: 2019, quarter: 4, salary: 49000 }, { year: 2019, quarter: 3, salary: 45600 }, { year: 2019, quarter: 2, salary: 44000 }, { year: 2019, quarter: 1, salary: 47000 }, { year: 2018, quarter: 4, salary: 45000 }, { year: 2018, quarter: 3, salary: 43500 }, { year: 2018, quarter: 2, salary: 0 }, { year: 2018, quarter: 1, salary: 0 } ],
//   "MissingBegin": [{ "quarter": 2, "salary": 58445, "year": 2020 }, {"quarter": 1, "salary": 58138, "year": 2020 }, { "quarter": 4, "salary": 57832, "year": 2019 }, { "quarter": 3, "salary": 57546, "year": 2019 }, {"quarter": 2, "salary": 57102, "year": 2019 }, { "quarter": 1, "salary": 57236, "year": 2019 }, { "quarter": 4, "salary": 56863, "year": 2018 }, {"quarter": 3, "salary": 56155, "year": 2018 }, { "quarter": 2, "salary": 56959, "year": 2018 }, { "quarter": 1, "year": 2018 }, {"quarter": 4, "salary": 56602, "year": 2017 }, { "quarter": 3, "year": 2017 }],
//   "MissingInBetween": [{ "quarter": 2, "salary": 58445, "year": 2020 }, {"quarter": 1, "salary": 0, "year": 2020 }, { "quarter": 4, "salary": 57832, "year": 2019 }, { "quarter": 3, "salary": 57546, "year": 2019 }, {"quarter": 2, "salary": 57102, "year": 2019 }, { "quarter": 1, "salary": 57236, "year": 2019 }, { "quarter": 4, "salary": 56863, "year": 2018 }, {"quarter": 3, "salary": 0, "year": 2018 }, { "quarter": 2, "salary": 56959, "year": 2018 }, { "quarter": 1, "year": 2018 }, {"quarter": 4, "salary": 56602, "year": 2017 }, { "quarter": 3, "year": 2017, "salary": 56500 }],
//   "MissingInBetweenDouble": [{ "quarter": 2, "salary": 58445, "year": 2020 }, {"quarter": 1, "salary": 0, "year": 2020 }, { "quarter": 4, "salary": 57832, "year": 2019 }, { "quarter": 3, "salary": 57546, "year": 2019 }, {"quarter": 2, "salary": 57102, "year": 2019 }, { "quarter": 1, "salary": 57236, "year": 2019 }, { "quarter": 4, "salary": 56863, "year": 2018 }, {"quarter": 3, "salary": 0, "year": 2018 }, { "quarter": 2, "salary": 0, "year": 2018 }, { "quarter": 1, "year": 2018 }, {"quarter": 4, "salary": 56602, "year": 2017 }, { "quarter": 3, "year": 2017, "salary": 56500 }]
// };

const normalizeLineChartData = (data2normalize) => {
  // earliest first as data arrives sorted from backend
  let data = data2normalize.reverse();

  data = data.map((s, index) => {
    const dateStr = `${s.year}-${s.quarter * 3 - 2}-1`;
    s.date = timeParse('%Y-%m-%d')(dateStr); // eslint-disable-line no-param-reassign

    if (s.salary === 0 || s.salary === undefined) {
      let i = index;
      let step = -1;
      let loop = true;

      s.missing = false; // eslint-disable-line no-param-reassign
      while (loop) {
        if (step === 1 && i + 1 === data.length) {
          loop = false;
        }
        if (i === 0) {
          step = 1;
        }
        i += step;
        const nextSalary = data[i].salary;
        if (nextSalary > 0 && nextSalary !== undefined) {
          s.salary = nextSalary; // eslint-disable-line no-param-reassign
          s.missing = true; // eslint-disable-line no-param-reassign
          loop = false;
        }
      }
    }

    // add percentFromPrev
    if (index === 0) {
      s.percentFromPrev = 0; // eslint-disable-line no-param-reassign
    } else {
      s.percentFromPrev = ((data[index].salary - data[index - 1].salary) / data[index - 1].salary) * 100; // eslint-disable-line no-param-reassign
    }

    // calculate and update the overall salary diff
    if (index === data.length - 1) {
      const firstSalary = data[0].salary;
      const lastSalary = data[index].salary;
      const overallDiff = ((lastSalary - firstSalary) / firstSalary) * 100;

      $('#percent-diff-value').text(overallDiff.toFixed(2));
      $('#percent-diff-value2').text(overallDiff.toFixed(2));
      $('.percent-diff').toggleClass('increase', overallDiff > 0);
    }

    return s;
  });

  data = data.map((s) => {
    const initialSalary = data[0].salary;
    s.amountFromFirst = s.salary - initialSalary; // eslint-disable-line no-param-reassign
    s.percentFromFirst = (s.amountFromFirst / initialSalary) * 100; // eslint-disable-line no-param-reassign

    return s;
  });

  // data = data.map(function(s, index) {
  //   let prevIndex = index === 0 ? 0 : index - 1;
  //   let nextIndex = data.length - 1 === index ? index : index + 1;
  //
  //   s.missingSiblingPrev = data[prevIndex].missing;
  //   s.missingSiblingNext = data[nextIndex].missing;
  //
  //   return s;
  // });

  // console.debug("line chart data", data);

  return data;
};

export const initLineChart = (chartSelector, chartData) => {
  // for testing local dev on mock data
  // chartData = chartData_Mock["MissingInBetweenDouble"];

  // normalize chart data
  const data = normalizeLineChartData(chartData || []);
  const yDeviation = 0; // positioning the plot on the yAxis

  function init() {
    // set the dimensions and margins of the graph
    const margin = { top: yDeviation, right: 30, bottom: 0, left: 5 };
    const width = 460 - margin.left - margin.right;
    const height = 200 - margin.top - margin.bottom;
    const tooltip = { width: 130, height: 60, x: -20, y: -44 };
    const colors = {
      green: 'forestgreen',
      red: '#d46262',
      strongGray: '#bfc3c5',
      gray: '#e0e2e3',
      gray1: '#8C9194',
      blue: '#61a9f9',
    };

    const bisectDate = bisector((d) => d.date).left;

    // append the svg object to the body of the page
    const svg = select(chartSelector)
      .append('svg')
      .attr('width', '100%')
      .attr('height', '100%')
      .attr('viewBox', `0 0 ${width + margin.left + margin.right + 20} ${height + margin.top + margin.bottom}`)
      .attr('fill', 'none')
      .append('g')
      .attr('transform',
        `translate(${margin.left},${margin.top})`);

    // Add X axis --> it is a date format
    const x = scaleTime()
      .domain(extent(data, (d) => d.date))
      .range([0, width]);

    svg.append('g')
      .attr('class', 'axis xAxis')
      .attr('transform', `translate(0,${height})`)
      .call(
        axisBottom(x)
          .tickFormat((date) => {
            const mon = date.getMonth();

            // return appropriate quarter for that month
            if (mon <= 2) {
              return 'Q1';
            } if (mon <= 5) {
              return 'Q2';
            } if (mon <= 8) {
              return 'Q3';
            }
            return 'Q4';
          }),
      )
      .selectAll('text')
      .style('text-anchor', 'start');

    // X-axis - Years Only
    svg.append('g')
      .append('g')
      .attr('class', 'axis xAxisYears')
      .attr('transform', `translate(0,${height})`)
      .call(
        axisTop(x)
          .tickSize(15, 0)
          .tickFormat((date) => {
            const mon = date.getMonth();
            const yr = date.getFullYear();
            if (mon === 0) {
              return yr;
            }
            return '';
          }),
      )
      .call((g1) => g1.select('.domain').remove())
      .selectAll('text')
      .attr('y', -3)
      .attr('x', 5)
      .style('text-anchor', 'start');

    // Add Y axis
    const formater = format('.1f');
    const maximumY = max(data, (d) => d.percentFromFirst);
    const minimumY = min(data, (d) => d.percentFromFirst);

    const y = scaleLinear()
      .domain([(minimumY * 0.98), (maximumY * 1.02)])
      .range([height + yDeviation, 0]);

    const yAxis = (g1) => g1
      .attr('class', 'axis yAxis')
      .call(axisRight(y)
        .ticks(5)
        .tickFormat((d) => `${formater(d)}%`)
        .tickSizeOuter(0))
      .call((g2) => g2.selectAll('.tick line').clone()
        .attr('x2', width)
        .attr('stroke', (d) => (d === 0 ? colors.strongGray : colors.gray)))
      .call((g3) => g3.select('.domain').remove())
      .selectAll('.yAxis text')
      .attr('transform', `translate(${width},0)`);

    svg.append('g')
      .call(yAxis);

    // Add the area
    svg.append('path')
      .datum(data)
      .attr('class', 'area')
      .attr('fill', colors.blue)
      .attr('fill-opacity', 0.2)
      .attr('stroke', 'none')
      .attr('d', area()
        .x((d) => x(d.date))
        .y0(height)
        .y1((d) => y(d.percentFromFirst)));

    // Add plot and missing lines
    const missingLine = line()
      .x((d) => x(d.date))
      .y((d) => y(d.percentFromFirst));
    const mainLine = line()
      .defined((d) => !d.missing)
      .x((d) => x(d.date))
      .y((d) => y(d.percentFromFirst));

    // Add the missing data plot line
    svg.append('path')
      .datum(data)
      .attr('class', 'missing')
      .attr('stroke', colors.gray1)
      .attr('stroke-width', 1)
      .attr('stroke-dasharray', '7,7')
      .attr('d', missingLine);

    // Add the plot line
    svg.append('path')
      .datum(data)
      .attr('class', 'plot')
      .attr('stroke', colors.blue)
      .attr('stroke-width', 2)
      .attr('d', mainLine);

    // Add the circle markers
    svg.selectAll('myCircles')
      .data(data)
      .enter()
      .append('circle')
      .attr('class', 'balls')
      .attr('fill', (d) => (d.missing ? colors.gray1 : colors.blue))
      .attr('stroke', 'none')
      .attr('cx', (d) => x(d.date))
      .attr('cy', (d) => y(d.percentFromFirst))
      .attr('r', 3);

    // ruler
    const rule = svg.append('g')
      .append('line')
      .attr('class', 'ruler')
      .attr('stroke', colors.green)
      .attr('y1', height)
      .attr('y2', 0);

    // mouse hover tooltip
    const focus = svg.append('g')
      .attr('class', 'focus')
      .style('display', 'none');

    focus.append('circle')
      .attr('class', 'outer-circle')
      .attr('r', 5)
      .style('fill', colors.green);
    focus.append('circle')
      .attr('class', 'inner-circle')
      .attr('r', 3)
      .style('fill', 'white');

    focus.append('rect')
      .attr('class', 'tooltip')
      .attr('width', tooltip.width)
      .attr('height', tooltip.height)
      .attr('x', -tooltip.width / 2)
      .attr('y', -tooltip.height - 10)
      .attr('rx', 4)
      .attr('ry', 4);

    focus.append('text')
      .attr('class', 'tooltip-quarter')
      .attr('x', tooltip.x)
      .attr('y', tooltip.y);

    focus.append('text')
      .attr('class', 'tooltip-percent')
      .attr('x', tooltip.x)
      .attr('y', tooltip.y + 14);

    svg.append('rect')
      .attr('class', 'tooltip-overlay')
      .attr('width', width)
      .attr('height', height)
      .on('mouseover', () => { focus.style('display', null); })
      .on('mouseout', () => { focus.style('display', 'none'); })
      .on('mousemove', mousemove);

    // Hide years tick at nodes 1 5 9
    const startingMonth = min(x.domain()).getMonth();
    let startingQ;
    switch (startingMonth) {
      case 3:
        startingQ = 2;
        break;
      case 6:
        startingQ = 3;
        break;
      case 9:
        startingQ = 4;
        break;
      default:
        startingQ = 1;
    }
    $(`.xAxisYears .tick:not(:nth-child(4n+${startingQ}))`).css('opacity', 0);

    function mousemove() {
      const x0 = x.invert(mouse(this)[0]);
      const i = bisectDate(data, x0, 1);
      const d0 = data[i - 1];
      const d1 = data[Math.min(i, data.length - 1)];
      const d = x0 - d0.date > d1.date - x0 ? d1 : d0;
      const leftFix = -100;
      const tooltipRightPadding = 6;

      // const format$ = format(',');
      // const trendAmountTxt = d.amountFromFirst === 0 ? 'NA' : `${d.amountFromFirst > 0 ? 'Up' : 'Down'} $${format$(Math.abs(d.amountFromFirst))}`;
      const firstQ = `Q${data[0].quarter} ${data[0].year}`;
      const percentFromFirstTxt = `${d.percentFromFirst > 0 ? '+' : ''}${formater(d.percentFromFirst)}% from ${firstQ}`;
      const percentFromPrevTxt = `${d.percentFromPrev > 0 ? '+' : ''}${formater(d.percentFromPrev)}% from previous`;

      // setting text content
      focus.select('.tooltip-quarter').text(`Q${d.quarter} ${d.year}`);
      focus.select('.tooltip-percent').html(
        `<tspan>${d.missing ? 'Missing' : percentFromFirstTxt}</tspan>
        ${d.missing ? '' : `<tspan x="${tooltip.x + 8}" dy="1.2em">${percentFromPrevTxt}</tspan>`}`,
      );

      // base marker and tooltip positioning
      focus.attr('transform', `translate(${x(d.date)},${y(d.percentFromFirst)})`);
      focus.select('.outer-circle').style('fill', d.missing ? colors.gray1 : colors.green);

      // vertical ruler
      rule.attr('transform', `translate(${x(d.date)},0)`)
        .attr('y2', y(d.percentFromFirst))
        .attr('stroke', d.missing ? colors.gray1 : colors.green);

      focus.select('.tooltip').attr('x', x(d.date) === 0 ? 0 : tooltip.x);
      focus.select('.tooltip').attr('y', y(d.percentFromFirst) < tooltip.height ? 15 : -tooltip.height - 10);
      focus.selectAll('text').attr('x', tooltip.x + tooltipRightPadding);

      // overrides in side-cases
      // tooltip overflows on left side
      if (x(d.date) + tooltip.x < 0) {
        focus.select('.tooltip').attr('x', 0);
        focus.selectAll('text, .tooltip-percent tspan').attr('x', tooltipRightPadding);
      }
      // tooltip overflows on right side
      if (x(d.date) + tooltip.width + tooltip.x > width) {
        focus.select('.tooltip').attr('x', tooltip.x + leftFix);
        focus.selectAll('text, .tooltip-percent tspan').attr('x', tooltip.x + leftFix + tooltipRightPadding);
      }

      // tooltip above and below marker positioning
      const isTooltipAboveMarker = y(d.percentFromFirst) < tooltip.height;
      const lineHeight = 13;
      const titleHeight = 8;
      const titleMarginBottom = 4;

      if (isTooltipAboveMarker) {
        focus.selectAll('.tooltip-quarter').attr('y', 35);
        focus.selectAll('.tooltip-percent').attr('y', 35 + titleMarginBottom + lineHeight);
      } else {
        focus.selectAll('.tooltip-quarter').attr('y', tooltip.y - titleHeight);
        focus.selectAll('.tooltip-percent').attr('y', tooltip.y + titleMarginBottom + lineHeight - titleHeight);
      }
    }
  }

  init();
};

export default initLineChart;
